import React from "react";
import { ListGroup } from "react-bootstrap";

const MessageList = ({ messages = [], textColor = "" }) => {
  return (
    <ListGroup>
      {messages.map((message, index) => (
        <ListGroup.Item
          key={index}
          style={{
            textAlign: "start",
            border: "none",
            color: textColor,
          }}
        >
          {message}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default MessageList;
